import React, {
  useState,
  useEffect,
} from 'react'
import { connect } from 'react-redux'
import {
  getOrders,
} from '../../store/actions'
import BaseTable from '../BaseTable'
import { sortText } from '../../utils/sortHelper'
import './index.css'
import { updateVarianceCheckingStatus } from '../../api'

const OrdersList = ({
  orders,
  onOrderSelect,
  onOrderStatusChange,
  selectedOrder,
  getOrders,
  newRun,
}) => {
  const [ordersSort, setOrdersSort] = useState({ isDesc: false, prop: '' })
  const [sortedOrders, setSortedOrders] = useState(orders)
  const [actionsDisabled, setActionsDisabled] = useState(false)


  const sortTable = ({ dataKey }) => {
    setOrdersSort({
      isDesc: ordersSort.prop === dataKey ? !ordersSort.isDesc : false,
      prop: dataKey,
    })
  }
  const onSelectOrderStatus = async (order, status) => {
    try {
      setActionsDisabled(true);

      // 1) Update backend status for this run
      await updateVarianceCheckingStatus(order.id, status);

      // 2) Tell parent so it can refreshOrders() / refreshVariance()
      // IMPORTANT: guard this so it doesn't crash if not provided
      if (typeof onOrderStatusChange === 'function') {
        await onOrderStatusChange(order.id, status);
      }
    } catch (error) {
      console.error("onSelectOrderStatus failed:", error);
    } finally {
      // FIX: re-enable UI
      setActionsDisabled(false);
    }
  };
  useEffect(() => {
    const { prop, isDesc } = ordersSort
    const sorted = [...orders].sort(sortText(prop, isDesc))
    setSortedOrders(sorted)
    // getOrders(sorted)

  }, [ordersSort, orders])

  const tableOptions = {
    columns: [...(orders.type === 'final_run' ? [{
      name: 'order-run',
      type: 'text',
      isSortable: true,
      dataKey: 'runOrder',
      cellPadding: '3rem',
    },
    ] : [{
      name: 'Order Run',
      type: 'order-run',
      isSortable: true,
      dataKey: 'runOrder',
      cellPadding: '3rem',
    }]),
    {
      name: 'Status',
      type: 'text',
      isSortable: true,
      dataKey: 'status',
      colorless: true,
    },
    {
      name: 'Bin/Part Centric',
      type: 'text',
      isSortable: true,
      dataKey: 'countingMode',
    },
    {
      name: 'Total Parts',
      type: 'text',
      isSortable: true,
      dataKey: 'partsCount',
      flexGrow: 'fg100-c',
    },
    {
      name: 'Inventory Value',
      type: 'text',
      isSortable: true,
      dataKey: 'inventoryValue',
      flexGrow: 'fg100-c',
    },
    {
      name: '-',
      type: 'dashed-link',
      dataKey: 'blank',
      flexGrow: 'fg100-c',
      options: ['aborted'],
    },
    {
      name: '',
      type: 'button',
      dataKey: 'button',
      flexGrow: 'fg100-c',
      options: ['completed'],
    },
    ],
  }
  return (
    <div className="orders-list">
      <BaseTable
        keyProp="id"
        onSort={sortTable}
        options={tableOptions}
        data={sortedOrders}
        padding={'0rem'}
        rowSelectable={true}
        selectedRow={selectedOrder}
        rowOnClick={onOrderSelect}
        onSelectStatus={onSelectOrderStatus}
        disable={true}
        ordersList={true}
      />
      {actionsDisabled && <div className="order-list__disabled" />}
    </div>
  )
}

const mapStateToProps = ({ data: { newRun, finalRun } }) => ({
  newRun,
  finalRun,
})
const mapDispatchToProps = ({ getOrders })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrdersList)

